
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import Landing from './components/pages/Landing';
import ShootingStarCursor from './components/ShootingStarCursor';
import Amazonads from './components/pages/Amazonads';
import Meta from './components/pages/Meta';
import Bing from './components/pages/Bing';
import FreeConsultation from './components/pages/Consultation';
import GoogleAdsPage from './components/pages/Google';
import Layout from './components/Layout';
import Contact from './components/pages/Contact';
import Adhero from './components/AdHero';
import GameLauncher from './components/GameLauncher';
import About from './components/pages/About';
import CaseStudy from './components/pages/CaseStudy';

// Policy and pricing pages
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsOfService from './components/pages/Terms';
import Pricing from './components/pages/Pricing';
import Refund from './components/pages/RefundPolicy';

function App() {
  return (
    <Router>
      <div className="app-container">
        <GameLauncher />
        <ShootingStarCursor />
        <ScrollToTop />

        <Routes>
          <Route element={<Layout />}>
            {/* Main pages */}
            <Route path="/" element={<Landing />} />
            <Route path="/google-ads" element={<GoogleAdsPage />} />
            <Route path="/meta-ads" element={<Meta />} />
            <Route path="/consultation" element={<FreeConsultation />} />
            <Route path="/bing-ads" element={<Bing />} />
            <Route path="/amazon-ads" element={<Amazonads />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/game" element={<Adhero />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-study" element={<CaseStudy />} />

            {/* Policy pages */}
            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            />

            <Route
              path="/terms-and-conditions"
              element={<TermsOfService />}
            />

            <Route
              path="/terms"
              element={<TermsOfService />}
            />

            <Route
              path="/refund-policy"
              element={<Refund />}
            />

            {/* Pricing */}
            <Route
              path="/pricing"
              element={<Pricing />}
            />

            {/* Performance marketing pricing alias */}
            <Route
              path="/pricing/performance-marketing"
              element={<Pricing />}
            />
          </Route>

          {/* Standalone game/hero page */}
          {/* Keep this route outside Layout only if intentional */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
